import * as React from 'react';
import { useTheme } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

interface PublicButtonProps {
  handleOpenDrawer: (event: React.MouseEvent<HTMLElement>) => void;
}

export function PublicButton(props: Readonly<PublicButtonProps>) {
  const { handleOpenDrawer } = props;
  const theme = useTheme();

  return (
    <Tooltip title="Menu">
      <IconButton data-id="public" onClick={handleOpenDrawer}>
        <theme.icons.burgerMenu sx={{ color: theme.palette.text.secondary }} />
      </IconButton>
    </Tooltip>
  );
}
